// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EmployeeUnitPricesSection__wrap--otqgN","yenfield":"EmployeeUnitPricesSection__yenfield--29hf7"};